var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('flash-card',{attrs:{"data":_vm.flashs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }